import { IngredientCreationPayload } from "@modules/ingredient/types";

import { IIngredientFormData, ImageCreationType } from "./types";

export const prepareImageUploadPromises = (
  uploadedFileList: FileList | null,
  createImage: ImageCreationType
) => {
  if (!uploadedFileList) {
    return
  }

  const list = Array.from(uploadedFileList).map((file) => {
    // when will develop Ingredient update
    if (!(file instanceof FileList)) {
    //   return Promise.resolve(file.url)
    }

    const formData = new FormData();

    formData.append('files[]', file);

    const response = createImage(formData).unwrap()

    return response
  })

  return list
};

export const prepareClonedData = (
  data: IIngredientFormData,
  imagePaths: string[],
): IngredientCreationPayload => {
  // The during of creation or updating we send all images, existing and new uploaded
  // the in backend we do all process
  // we exclude deleted items and deleting data by missing ids in payload

  const {
    existingImages,
    uploadedFileList,
    ...restOfData
  } = data;

  // uploadedFileList exclude from payload
  const array = existingImages?.map((img) => img.id) || []

  return {
    ...restOfData,
    // eslint-disable-next-line no-unsafe-optional-chaining
    // new uploaded and existing images together
    images: [...imagePaths, ...array],

  } as unknown as IngredientCreationPayload;
};
